import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'sprite-vault:trade-recipient:v1';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

// Tiny pub-sub so multiple components stay in sync across the page.
const listeners = new Set();
function notify(v) { listeners.forEach((fn) => fn(v)); }

export function useTradeRecipient() {
  const [recipient, setRecipientState] = useState(load);

  useEffect(() => {
    const fn = (v) => setRecipientState(v);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  const setRecipient = useCallback((user) => {
    if (user) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(user)); } catch { /* ignore */ }
    } else {
      try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    }
    notify(user);
  }, []);

  const clear = useCallback(() => setRecipient(null), [setRecipient]);

  return { recipient, setRecipient, clear };
}
